/// <reference path="../../../typings/index.d.ts" />
module Meevo {
  'use strict';

  export interface IParameterMetadata {
    context: IContext; 
    params: any;
  }

   export class ParameterMetadata implements IParameterMetadata {
    constructor(public context: IContext, public params: any) {

    }
  }
}
